module.exports = require("node:console");